import { getDeliveryLogListApi } from "apis";
import { DataTableV2, Intro } from "components/commons";
import { StationContext } from "contexts";
import { FormMode, Path } from "enums";
import { useRouter } from "hooks";
import useDataTable from "hooks/useDataTable";
import locale from "localization";
import { useContext, useState } from "react";
import { deliveryLogColumns } from "./delivery-logs-list-column";
import { mapDataToList, mapFilterToRequest } from "./delivery-logs-list-mapper";
import { initialFilterState } from "./delivery-logs-filter.state";
import DeliveryLogsFilter from "./delivery-logs-filter";
import { ImagePreview } from "components/modals";

const DeliverLogsModule = () => {
  const { station } = useContext(StationContext);
  const router = useRouter();
  const [imageUrl, setImageUrl] = useState("");
  const { filter, table, search } = useDataTable({
    api: {
      api: getDeliveryLogListApi,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: {
      initialState: initialFilterState(),
      mapper: mapFilterToRequest,
      disregardFilterCount: {
        dateType: true,
      },
    },
    table: {
      key: "deliveries",
      mapper: (deliveryLog) =>
        mapDataToList({
          deliveryLog,
          onClickView: (deliveryId) => {
            router.push(Path.ViewDeliveryLogDetails(deliveryId, FormMode.View));
          },
        }),
      columns: deliveryLogColumns,
    },
  });

  return (
    <div>
      <Intro title={locale.deliveryLogs} />
      <DeliveryLogsFilter {...filter} {...search} />
      <DataTableV2 {...table} />
      <ImagePreview value={imageUrl} onClose={() => setImageUrl("")} />
    </div>
  );
};

export default DeliverLogsModule;
